import { render, staticRenderFns } from "./ActView.vue?vue&type=template&id=f45c28ca&scoped=true&"
import script from "./ActView.vue?vue&type=script&async=true&lang=js&"
export * from "./ActView.vue?vue&type=script&async=true&lang=js&"
import style0 from "./ActView.vue?vue&type=style&index=0&id=f45c28ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f45c28ca",
  null
  
)

export default component.exports